import { ExportConfigItem } from 'store/api/pdfReport/pdfReportApiTypes';
import { Settings, ToggleSectionKey } from './export-modal.types';

export const DEFAULT_SETTINGS: Settings = {
  analysis: { tar: true, bic: true, off: true },
  improvements: { tar: true, bic: true, off: true },
};

type SettingsGroup = keyof Settings;

const ITEM_MAP: Record<
  string,
  { group: SettingsGroup; key: ToggleSectionKey; title: string }
> = {
  'analysis-technical': {
    group: 'analysis',
    key: 'tar',
    title: 'Technical Accessibility',
  },
  'analysis-information': {
    group: 'analysis',
    key: 'bic',
    title: 'Business Info Completeness',
  },
  'analysis-offerings': {
    group: 'analysis',
    key: 'off',
    title: 'Offerings',
  },
  'improvements-technical': {
    group: 'improvements',
    key: 'tar',
    title: 'Technical Accessibility',
  },
  'improvements-information': {
    group: 'improvements',
    key: 'bic',
    title: 'Business Info Completeness',
  },
  'improvements-offerings': {
    group: 'improvements',
    key: 'off',
    title: 'Offerings',
  },
};

export const settingsFromItems = (items?: ExportConfigItem[]): Settings => {
  if (!items?.length) return DEFAULT_SETTINGS;
  const settings: Settings = {
    analysis: { ...DEFAULT_SETTINGS.analysis },
    improvements: { ...DEFAULT_SETTINGS.improvements },
  };
  for (const item of items) {
    const mapping = item.name ? ITEM_MAP[item.name] : undefined;
    if (mapping) settings[mapping.group][mapping.key] = item.enabled;
  }
  return settings;
};

export const itemsFromSettings = (
  settings: Settings,
  cachedItems: ExportConfigItem[] = []
): ExportConfigItem[] =>
  cachedItems.map(item => {
    const mapping = item.name ? ITEM_MAP[item.name] : undefined;
    return mapping
      ? { ...item, enabled: settings[mapping.group][mapping.key] }
      : item;
  });
